import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { ViewStyles } from '@bubble-ui/primitive-view';
import { isLollipop } from '@bubble-ui/particle-design-versions';
export var getDefaultStyleSheet = _ref => {
  var {
    checked,
    designContext,
    designVersion,
    disabled,
    error,
    highlighted,
    hovered,
    isIndeterminate,
    keyboardFocused,
    legal,
    pressed,
    warning,
    disableClickableLabel
  } = _ref;
  var interactiveState = disabled ? 'disabled' : pressed ? 'pressed' : hovered ? 'hovered' : 'default';
  var BackgroundAndBorderArgs = {
    interactiveState,
    successState: error ? 'error' : warning ? 'warning' : 'default',
    isChecked: checked || isIndeterminate ? 'checked' : 'default'
  };
  var textStyle = legal ? 'legal' : 'default';
  var textSuccessState = highlighted && error ? 'error' : highlighted && warning ? 'warning' : 'default';
  var backgroundColor = designContext.get('switch-checkbox/background-color', BackgroundAndBorderArgs);
  var borderColor = designContext.get('switch-checkbox/border-color', BackgroundAndBorderArgs);
  var keyboardFocusedBorderColor = designContext.get('switch-checkbox/keyboard-focused-border-color', BackgroundAndBorderArgs);
  var cornerRadius = designContext.get('switch-checkbox/corner-radius').pixelValue;
  var borderRadius = isLollipop(designVersion) ? 5 : cornerRadius;
  var checkboxTextColor = designContext.get('switch-checkbox/text-color', {
    interactiveState,
    textSuccessState
  });
  var checkboxTextStyle = designContext.get('switch-checkbox/text-style', {
    textStyle
  });
  var checkboxTitleTextColor = designContext.get('switch-checkbox/title-text-color', {
    interactiveState
  });
  var checkboxTitleTextStyle = designContext.get('switch-checkbox/title-text-style');
  var checkboxDescriptionTextColor = designContext.get('switch-checkbox/description-text-color', {
    interactiveState
  });
  var checkboxDescriptionTextStyleDefault = designContext.get('switch-checkbox/description-text-style');
  var checkboxDescriptionTextStyle = checkboxDescriptionTextStyleDefault;
  var iconsWrapperStyle = {
    display: 'block',
    position: 'absolute',
    top: 0,
    left: 0,
    cursor: disabled ? 'auto' : 'pointer',
    transform: legal ? 'translateY(0px)' : 'translateY(5px)'
  };
  return {
    mainWrapper: _objectSpread({}, ViewStyles),
    main: {
      position: 'relative',
      paddingTop: legal ? 1 : 2,
      paddingBottom: legal ? 4 : 3
    },
    overlayStyle: {
      borderRadius: isLollipop(designVersion) ? 8 : designContext.get('switch-checkbox/keyboard-focus-corner-radius').pixelValue,
      borderColor: keyboardFocused ? keyboardFocusedBorderColor.toString() : designContext.get('colors/borders/transparent').toString(),
      borderWidth: 2,
      borderStyle: 'solid',
      bottom: 0,
      height: 30,
      boxSizing: 'border-box',
      left: -5,
      position: 'absolute',
      right: 0,
      top: legal ? -5 : 0,
      transition: 'border-color .2s ease',
      width: 30,
      zIndex: -1
    },
    boxStyle: {
      backgroundPositionX: '0%',
      backgroundPositionY: '0%',
      backgroundColor: backgroundColor.toString(),
      borderColor: borderColor.toString(),
      borderRadius,
      borderStyle: 'solid',
      borderWidth: 1,
      boxSizing: 'border-box',
      cursor: disabled ? 'auto' : 'pointer',
      height: 20,
      left: 0,
      position: 'absolute',
      top: legal ? 0 : 5,
      transition: 'background-color .2s ease, border-color .2s ease',
      width: 20
    },
    inputStyle: {
      height: 0,
      opacity: 0,
      position: 'absolute',
      width: 0,
      left: 0,
      top: 0,
      pointerEvents: 'none'
    },
    labelStyle: {
      cursor: disabled || disableClickableLabel ? 'auto' : 'pointer',
      display: 'block'
    },
    textStyle: _objectSpread(_objectSpread({
      maxWidth: '100%',
      color: checkboxTextColor.toString()
    }, checkboxTextStyle.styles()), {}, {
      lineHeight: "".concat(checkboxTextStyle.styles().lineHeight, "px"),
      cursor: disabled || disableClickableLabel ? 'auto' : 'pointer',
      display: 'block',
      marginLeft: 28,
      marginTop: legal ? 1 : 2,
      textRendering: 'geometricPrecision',
      WebkitFontSmoothing: 'antialiased',
      textSizeAdjust: 'none'
    }),
    // we use both iconWrapperStyle and checkmarkWrapperStyle in order to keep backward compatibility for style-sheet-overrides
    iconWrapperStyle: iconsWrapperStyle,
    checkmarkWrapperStyle: iconsWrapperStyle,
    checkmarkTickStyle: {
      colorToken: 'switch-checkbox/icon-color'
    },
    iconColor: {
      colorToken: 'switch-checkbox/icon-color'
    },
    titleStyle: _objectSpread(_objectSpread({}, ViewStyles), {}, {
      marginLeft: 28,
      paddingTop: 7
    }),
    titleTextStyle: _objectSpread(_objectSpread({
      color: checkboxTitleTextColor.toString()
    }, checkboxTitleTextStyle.styles()), {}, {
      margin: 0,
      paddingLeft: 0,
      paddingRight: 0,
      boxSizing: 'border-box',
      flexShrink: 0,
      textRendering: 'geometricPrecision',
      WebkitFontSmoothing: 'antialiased',
      wordBreak: 'break-word',
      textAlign: 'left',
      marginBottom: -10,
      marginTop: -5,
      paddingBottom: 3,
      paddingTop: 2
    }),
    descriptionTextStyle: _objectSpread({
      marginTop: -6,
      color: checkboxDescriptionTextColor.toString()
    }, checkboxDescriptionTextStyle.styles()),
    rootStyle: {}
  };
};
//# sourceMappingURL=getDefaultStyleSheet.js.map